import { toast } from "react-toastify";
import clsx from "clsx";

import type {
  INotifyPromiseProps,
  INotifyProps,
} from "@components/organisms/notify/types";
import { INotifCardVariantsEnum } from "@components/organisms/notify/types";
import { NotifCard } from "@components/organisms/notify/notifCard";

const info = (props: INotifyProps) => {
  toast.info(
    <NotifCard {...props} variant={INotifCardVariantsEnum.Information} />,
    {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
    },
  );
};

const error = ({ toastId, ...props }: INotifyProps) => {
  toast.error(<NotifCard {...props} variant={INotifCardVariantsEnum.Error} />, {
    bodyClassName: clsx("toastBody"),
    className: clsx("toast"),
    toastId,
  });
};

const success = (props: INotifyProps) => {
  toast.success(
    <NotifCard {...props} variant={INotifCardVariantsEnum.Success} />,
    {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
    },
  );
};

const warning = (props: INotifyProps) => {
  toast.warning(
    <NotifCard {...props} variant={INotifCardVariantsEnum.Warning} />,
    {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
    },
  );
};

const feature = (props: INotifyProps) => {
  toast.warning(
    <NotifCard {...props} variant={INotifCardVariantsEnum.Feature} />,
    {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
    },
  );
};

const promise = async <TData = unknown, TError = unknown>(
  props: INotifyPromiseProps<TData, TError>,
) => {
  return toast.promise<TData, TError>(props.promise, {
    pending: {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
      render: (
        <NotifCard
          {...props.pending}
          variant={INotifCardVariantsEnum.Promise}
        />
      ),
    },
    success: {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
      render: (data) => {
        return (
          <NotifCard
            {...props.pending}
            variant={INotifCardVariantsEnum.Success}
            title={
              typeof props.success.title === "function"
                ? props.success.title(data.data)
                : props.success.title
            }
            description={
              typeof props.success.description === "function"
                ? props.success.description(data.data)
                : props.success.description
            }
          />
        );
      },
    },
    error: {
      bodyClassName: clsx("toastBody"),
      className: clsx("toast"),
      render: (data) => {
        return (
          <NotifCard
            {...props.pending}
            variant={INotifCardVariantsEnum.Error}
            title={
              typeof props.error.title === "function"
                ? props.error.title(data.data)
                : props.error.title
            }
            description={
              typeof props.error.description === "function"
                ? props.error.description(data.data)
                : props.error.description
            }
          />
        );
      },
    },
  });
};

export const notify = {
  info,
  error,
  success,
  warning,
  feature,
  promise,
};
